import VerificationIconWrapper from './VerificationIconWrapper';

export default VerificationIconWrapper;
